import React, { useState, useEffect } from "react";
import {Dialog, DialogTitle, DialogContent, Drawer, IconButton, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import './ConfirmDeleteItem.css'

interface ConfirmDeleteItemModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    t: (key: string) => string;
}

const BREAKPOINT = 991; // Switch tra Dialog e Drawer

const ConfirmDeleteItemModal: React.FC<ConfirmDeleteItemModalProps> = ({ open, onClose, onConfirm, t }) => {
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > BREAKPOINT);

    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth > BREAKPOINT);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const closeButton = (
        <IconButton onClick={onClose} style={{ position: "absolute", top: 8, right: 8 }}>
            <CloseIcon />
        </IconButton>
    );

    const content = (
        <div className="ModalDeleteItemContainer" style={{ padding: "16px", textAlign: "center", position: "relative" }}>
            <p>{t("modalDeleteItemParagraph")}</p>
            <div className="ConfirmDelete" onClick={onConfirm}>
                <button className="Fgift-button">{t("deleteItemButton")}</button>
            </div>
            <div className="CancelDelete" onClick={onClose}>
                <button className="Fgift-button" style={{ backgroundColor: "transparent", textDecoration: "underline", color: "#33383C", border: "0px" }}>
                    {t("cancelDeleteButton")}
                </button>
            </div>
        </div>
    );

    return isDesktop ? (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth className={'ConfirmDeleteItemDialog'}>
            <DialogTitle className={'ConfirmDeleteTitle'}>
                {t('modalDeleteItemTitle')}
                {closeButton}
            </DialogTitle>
            <DialogContent>{content}</DialogContent>
        </Dialog>
    ) : (
        <Drawer anchor="bottom" open={open} onClose={onClose} PaperProps={{ style: { borderRadius: "0", padding: "0" } }}>
            <div style={{ position: "relative", padding: "16px 24px", borderBottom: "1px solid #ccc" }}>
                <Typography variant="h6">{t("modalDeleteItemTitle")}</Typography>
                {closeButton}
            </div>
            {content}
        </Drawer>
    );
};

export default ConfirmDeleteItemModal;
